import {
  IconNote,
  IconPaperclip,
  IconPhotoScan,
  IconScript,
  IconWorldWww,
} from "@tabler/icons-react";

import { EvidenceType } from "@oneleet/api_client";

export const EVIDENCE_TYPES: Record<EvidenceType, { icon: React.ReactNode }> = {
  [EvidenceType.IMAGE]: {
    icon: <IconPhotoScan className="text-neutral-550 size-4 shrink-0" />,
  },
  [EvidenceType.FILE]: {
    icon: <IconPaperclip className="text-neutral-550 size-4 shrink-0" />,
  },
  [EvidenceType.LINK]: {
    icon: <IconWorldWww className="text-neutral-550 size-4 shrink-0" />,
  },
  [EvidenceType.IN_APP_DOCUMENT]: {
    icon: <IconScript className="text-neutral-550 size-4 shrink-0" />,
  },
  [EvidenceType.NOTE]: {
    icon: <IconNote className="text-neutral-550 size-4 shrink-0" />,
  },
};
